var map = {
	"./0.jpg": 7209,
	"./1.jpg": 459,
	"./10.jpg": 5402,
	"./11.jpg": 7276,
	"./2.jpg": 4210,
	"./3.jpg": 2412,
	"./4.jpg": 1556,
	"./5.jpg": 5218,
	"./6.jpg": 6028,
	"./7.jpg": 8225,
	"./8.jpg": 8736,
	"./9.jpg": 6332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9680;